module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_01-47afe7641c3d9645d4f4f7a83cdd8537.png";